"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.test = test;
exports.render = render;
const dates = require("../dates");
const dateStart = require("../date-start");
const encode = require("../encode");
const h = require("../html");
const loader = require("../loader");
const lineupsSheet = require("../tcb/lineups-sheet");
const kRecentPeople = 'lineups-RecentPeople';
function cmp(v1, v2) {
    return v1 < v2 ? -1 : v1 == v2 ? 0 : 1;
}
class Lineups {
    constructor() {
        this.timezone = new dates.Timezone(9);
        this.lineupsLoader = new loader.Loader('lineupsData', 'Refresh Lineups', lineupsSheet.fetchSheet, this.render.bind(this), 
        /*refreshSeconds=*/ 0);
        this.filterStyle = h.style(document.head);
    }
    render() {
        const e = document.querySelector('#appDiv');
        if (e) {
            h.removeAllChildren(e);
            const header = h.div(e, 'no-print');
            const loader = h.div(header);
            this.lineupsLoader.render(loader);
            h.hr(header);
            const events = h.div(e);
            const doc = this.loadLineups();
            this.renderEvents(events, doc.extractEvents());
        }
    }
    loadLineups() {
        const data = this.lineupsLoader.getData();
        if (data) {
            return new lineupsSheet.Doc(data);
        }
        else {
            throw 'No lineups data';
        }
    }
    groupEventsByDay(events) {
        const eventsByDay = new Map();
        for (const event of events) {
            const day = event.date;
            if (!eventsByDay.has(day)) {
                eventsByDay.set(day, []);
            }
            eventsByDay.get(day)?.push(event);
        }
        return eventsByDay;
    }
    hasPerson(eventDiv, person) {
        for (const personSpan of eventDiv.querySelectorAll('.role-person')) {
            if (personSpan.textContent == person) {
                return true;
            }
        }
        return false;
    }
    revealStyle(person) {
        if (person == '*') {
            return '';
        }
        const personSelector = `.x${encode.hex(person)}`;
        return `.event {
      display: none;
    }
    .event:has(${personSelector}) {
      display: block;
    }

    ${personSelector} {
      font-weight: bold;
    }
    `;
    }
    revealPerson(eventsDiv, person) {
        this.filterStyle.textContent = this.revealStyle(person);
    }
    personsFromEvents(events) {
        const persons = new Set();
        for (const event of events) {
            for (const role of event.roles) {
                persons.add(role.person);
            }
        }
        return persons;
    }
    makePersonUrl(person) {
        const url = new URL(document.location.toString());
        const params = new URLSearchParams();
        params.set('person', person);
        url.hash = params.toString();
        return url.toString();
    }
    updateLink(linkEl, person) {
        if (person == '*') {
            linkEl.innerHTML = 'Select a performer.';
            return;
        }
        const personUrl = this.makePersonUrl(person);
        h.a(linkEl, personUrl).textContent =
            `Link to schedule for ${person}. Select yourself and bookmark it!`;
        const button = h.button(linkEl);
        button.textContent = 'Copy to clipboard';
        button.onclick = () => {
            navigator.clipboard.writeText(personUrl);
        };
    }
    setSelectedPerson(person, linkEl) {
        params.set('person', person);
        document.location.hash = params.toString();
        this.updateLink(linkEl, person);
    }
    getSelectedPerson(hash) {
        const params = new URLSearchParams(hash.substring(1));
        return params.get('person') || '*';
    }
    renderPersonFilter(parent, events) {
        const linkEl = h.div(parent, 'link');
        const select = h.select(parent, 'person-selector');
        select.onchange = () => {
            const selectedPerson = select.selectedOptions[0].textContent || '*';
            this.setSelectedPerson(selectedPerson, linkEl);
        };
        const selectedPerson = this.getSelectedPerson(document.location.hash);
        this.updateRecentPeople(selectedPerson);
        this.updateLink(linkEl, selectedPerson);
        const persons = ['*'];
        persons.push(...Array.from(this.personsFromEvents(events)).sort((p1, p2) => cmp(p1.toLowerCase(), p2.toLowerCase())));
        for (const person of persons) {
            const option = h.option(select);
            option.textContent = person;
            if (selectedPerson == person) {
                option.selected = true;
                queueMicrotask(() => this.revealPerson(parent, person));
            }
        }
        const shortcutsDiv = h.div(parent);
        this.renderShortcuts(shortcutsDiv);
        window.addEventListener('hashchange', e => {
            shortcutsDiv.innerHTML = '';
            this.updateRecentPeople(this.getSelectedPerson(new URL(e.newURL).hash));
            this.renderShortcuts(shortcutsDiv);
        });
    }
    renderShortcuts(shortcutsElem) {
        h.div(shortcutsElem).textContent = 'Shortcuts';
        const recentPeople = this.loadRecentPeople();
        recentPeople.unshift('*');
        for (const person of recentPeople) {
            const personDiv = h.div(shortcutsElem);
            h.a(personDiv, this.makePersonUrl(person)).textContent =
                person == '*' ? 'Everyone' : person;
        }
    }
    loadRecentPeople() {
        const recentPeople = localStorage.getItem(kRecentPeople);
        if (recentPeople === null) {
            return [];
        }
        const data = JSON.parse(recentPeople);
        const people = data['people'];
        if (!(people instanceof Array)) {
            console.error('people was not an array', people);
            return [];
        }
        const result = [];
        for (const person of people) {
            if (!(typeof person === 'string')) {
                console.error('person is not a string', person);
                continue;
            }
            result.push(person);
        }
        return result;
    }
    updateRecentPeople(person) {
        if (person == '*') {
            return;
        }
        const recentPeople = this.loadRecentPeople();
        const filteredPeople = recentPeople.filter(p => p != person);
        filteredPeople.unshift(person);
        while (filteredPeople.length > 3) {
            filteredPeople.pop();
        }
        localStorage.setItem(kRecentPeople, JSON.stringify({ people: filteredPeople }));
    }
    renderWeeks(parent, events) {
        // Make a list of week-starts.
        const nowWeekStart = dates
            .getWeekStart(this.timezone.getSimpleDateFromNow())
            .toString();
        const weekStarts = new Set();
        for (const event of events) {
            const weekStart = dates
                .getWeekStart(this.timezone.getSimpleDateFromString(event.date))
                .toString();
            if (weekStart >= nowWeekStart) {
                weekStarts.add(weekStart);
            }
        }
        // Don't include the current week in the list of weeks.
        const start = this.getStart() || nowWeekStart;
        if (start !== null) {
            weekStarts.delete(start.toString());
        }
        // Render links to the week-starts.
        const sortedWeekStarts = Array.from(weekStarts).sort();
        for (const weekStart of sortedWeekStarts) {
            const url = new URL(document.location.toString());
            const params = this.parseHashParams();
            params.set('week', weekStart);
            url.hash = params.toString();
            h.a(h.div(parent), url.toString()).textContent =
                `Week starting ${weekStart}`;
        }
        h.hr(parent);
        const startString = start?.toString() || sortedWeekStarts[0];
        h.div(parent, 'week-title').textContent =
            `Events for week of ${startString}`;
        return this.timezone.getSimpleDateFromString(startString);
    }
    renderEvents(parent, events) {
        this.renderPersonFilter(parent, events);
        h.hr(parent);
        const start = this.renderWeeks(parent, events);
        const daysEl = h.div(parent, 'days');
        h.hr(parent);
        this.renderDays(daysEl, events, start);
    }
    parseHashParams() {
        return new URLSearchParams(document.location.hash.substring(1));
    }
    getStart() {
        const params = this.parseHashParams();
        const week = params.get('week');
        if (week === null) {
            return null;
        }
        return dateStart.getWeekStart(this.timezone, week);
    }
    getEnd(start) {
        return start.addWeeks(1);
    }
    renderDays(daysEl, events, start) {
        const eventsByDay = this.groupEventsByDay(events);
        const end = this.getEnd(start);
        for (const [day, events] of eventsByDay) {
            const simpleDay = this.timezone.getSimpleDateFromString(day);
            if (dates.SimpleDate.compare(simpleDay, start) == -1) {
                continue;
            }
            if (dates.SimpleDate.compare(simpleDay, end) >= 0) {
                continue;
            }
            const dayDiv = h.div(daysEl, 'day');
            h.span(dayDiv, 'date').textContent = day;
            h.span(dayDiv).textContent = ' ';
            h.span(dayDiv, 'dayName').textContent = this.timezone
                .getSimpleDateFromString(day)
                .utcDate.toLocaleDateString('en-US', { weekday: 'short' });
            events.sort((e1, e2) => cmp(e1.startTime, e2.startTime));
            for (const event of events) {
                if (!event.title) {
                    continue;
                }
                const eventDiv = h.div(dayDiv, 'event');
                const timeCalEl = h.div(eventDiv, 'time-cal');
                const timeEl = h.span(timeCalEl, 'time');
                timeEl.textContent = event.startTime;
                h.span(timeCalEl, '').textContent = ' ';
                const calEl = h.a(timeCalEl, 'cal');
                calEl.textContent = 'iCal';
                // Disabling ical, it's upset by Japanese events.
                // calEl.href = "data:text/calendar," + ical.forEvent(event);
                const titleDiv = h.div(eventDiv, 'title');
                titleDiv.textContent = event.title;
                const rolesDiv = h.div(eventDiv, 'roles');
                for (const role of event.roles) {
                    const roleDiv = h.div(rolesDiv, 'role');
                    h.span(roleDiv, 'role-description').textContent = role.description;
                    h.span(roleDiv).textContent = ' ';
                    h.span(roleDiv, `role-person x${encode.hex(role.person)}`).textContent = role.person;
                }
            }
        }
    }
}
const params = new URLSearchParams(window.location.hash.substring(1));
const app = new Lineups();
async function test() {
    const html = await fetch('https://localhost/apps/test/lineups.html').then(r => r.text());
    const sheet = new lineupsSheet.Doc(html);
    sheet.extractEvents();
}
async function render() {
    window.onhashchange = app.render.bind(app);
    app.render();
}
